/** Chemins qui acceptent `?league=<id>&season=<code>` : les cibles des liens du
 *  tiroir d'engagements. Ailleurs, les deux paramètres ne veulent rien dire. */
export const SCOPED_PATH_PREFIXES = ["/management/players", "/management/staff", "/clubs/"] as const;

export type ScopeDecision =
  | { kind: "none" }
  | { kind: "wait" }
  | { kind: "apply"; leagueId: string | null; season: string | null; search: string };

export function hasScopeParams(search: string): boolean {
  const params = new URLSearchParams(search);
  return params.has("league") || params.has("season");
}

/** Chaque paramètre est appliqué pour lui-même : une ligue inaccessible est
 *  ignorée sans empêcher une saison valide. Les deux sont toujours retirés. */
export function decideScopeParams(
  pathname: string,
  search: string,
  known: { leagueIds?: string[] | null; seasons?: string[] | null },
): ScopeDecision {
  if (!SCOPED_PATH_PREFIXES.some((p) => pathname.startsWith(p))) return { kind: "none" };
  const params = new URLSearchParams(search);
  const league = params.get("league");
  const season = params.get("season");
  if (league === null && season === null) return { kind: "none" };
  if ((league !== null && !known.leagueIds) || (season !== null && !known.seasons)) return { kind: "wait" };
  params.delete("league");
  params.delete("season");
  const rest = params.toString();
  return {
    kind: "apply",
    leagueId: league && known.leagueIds!.includes(league) ? league : null,
    season: season && known.seasons!.includes(season) ? season : null,
    search: rest ? `?${rest}` : "",
  };
}

/** La liste des clubs est filtrée par ligue et saison, et sert l'ancienne portée
 *  pendant son refetch (`keepPreviousData`) : rediriger avant qu'elle soit posée
 *  renverrait vers `/clubs` un lien pourtant valide. */
export function teamProfileGuard(p: { found: boolean; settled: boolean }): "wait" | "redirect" | "show" {
  if (p.found) return "show";
  return p.settled ? "redirect" : "wait";
}
